import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type UpdateViewColumnV3 = OpalApi<'UpdateViewColumnV3', 200>

export const updateViewColumn: UpdateViewColumnV3 = async (args = {}) => {
  if (!args.params?.path?.view_column_id) {
    throw new Error('updateViewColumn: params.path.view_column_id is required')
  }

  const url = new URL(
    `/loupe/v3/view_columns/${args.params.path.view_column_id}`,
    window.location.origin
  )

  return HttpClient()
    .patch(url.toString(), args.requestBody)
    .then((res) => res.data)
}
